import React,{useState, useEffect} from 'react'
import $ from 'jquery';
import { environment } from '../environment/production';
import axios from 'axios';

function EducationQualification(props) {
  let i=1
  let [initialization,setInitialization]=useState(1)
  let [initializationLoad,setInitializationLoad]=useState(1)
  let [datalength,setDataLength]=useState(1)
  const [createEduStatus,setCreateEduStatus]=useState('0')
  const [data,setData]=useState({
  
    data:'',
    university_name:'',
    degree:'',
    year_of_passing:'',
    marks_obtained:'',
    subject_specialization:''
  })
  const [formdata,setFormData]=useState({
    user_id:parseInt(sessionStorage.getItem("user_id")),
    university_name:'',
    degree:'',
    year_of_passing:'',
    marks_obtained:'',
    subject_specialization:''
  })
  const [apiCall,setApiCall]=useState(0)
  const options={
    data:{
      formdata
    },
    headers:{
      'Authorization':sessionStorage.getItem("access_token")
    }
  }

  const deleteEducationOnAdd=()=>{
    
    axios.post(environment.apiUrl+"/Education/getEducationDetails",JSON.stringify({user_id:parseInt(sessionStorage.getItem("user_id"))}),{headers:(options.headers)})
    .then((response)=>{
     
      if(response['data']['status']==1){
       
        
        props.data(response['data']['status'])
        setData({
          ...data,data:response['data']
        })
       
         
          setInitialization(response.data.data.length+1)
          if(response.data.data.length!==1){
            
          
            for(let i=response.data.data.length-2;(response.data.data.length-1)>i;i++){
              setDataLength(i+2)
            document.querySelector('#edu_'+ i).addEventListener('click',()=>{
              let a=i;
              axios.post(environment.apiUrl+"/Education/deleteEducationList",JSON.stringify({edu_id:i+1}),{headers:(options.headers)})
              .then((response)=>{
                if(response.data.status==1){
                  $('#row_'+a).hide()
                  alert("Education deleted successfully")
                }
              })
          
            } )
            }
           
       
      }else{
        
          for(let i=0;(response.data.data.length-1)>=i;i++){
            setDataLength(i+2)
          document.querySelector('#edu_'+ i).addEventListener('click',()=>{
            let a=i;
            axios.post(environment.apiUrl+"/Education/deleteEducationList",JSON.stringify({edu_id:i+1}),{headers:(options.headers)})
            .then((response)=>{
              if(response.data.status==1){
                $('#row_'+a).hide()
                alert("Education deleted successfully")
              }
            })
        
          } )
          }
         
     
      }
        
      }
    })
  }

  const handleFormValidation=()=>{
    var regexp=/^[a-zA-Z ._,]+$/;
    // var regexp=/[^a-zA-Z0-9 . _]/g;
     if(formdata.university_name == ''){
      alert("University name is required")
     }else if(formdata.degree == ''){
      alert("Degree is required")
     }else if(formdata.subject_specialization == ''){
      alert("Subject specialization is required")
     }else if(!regexp.test(formdata.university_name)){
    alert("Special Charachter is not Allowed in university name")
   }else if(!regexp.test(formdata.degree)){
    alert("Special Charachter is not Allowed in Degree")
   }else if(!regexp.test(formdata.subject_specialization)){
    alert("Special Charachter is not Allowed in subject specialization")
   }else{
    if(formdata.university_name!=='' && formdata.degree!=='' && formdata.year_of_passing!=='' && formdata.marks_obtained!=='' && formdata.subject_specialization!==''){
      axios.post(environment.apiUrl+"/Education/Create",JSON.stringify(options.data.formdata),{headers:(options.headers)})
      .then((response)=>{
        if(response['data']['status']==1){
          document.getElementById("university_name").value="";
          document.getElementById("degree").value="";
          document.getElementById("year_of_passing").value="";
          document.getElementById("division_or_marks_obtained").value="";
          document.getElementById("subject_or_specialization").value="";
          setCreateEduStatus('1')
          props.data(response['data']['status'])
          alert(response['data']['msg'])

          if(createEduStatus=='0'){
            $('.show_table').append('<table class="table-wrapper">'+
            '<thead>'+
            '<tr>'+
            '<th scope="col">S.No.</th>'+
            '<th colspan="2" scope="col">Name of University/<br/>Equivalent Institute</th>'+
            '<th scope="col">Degree</th>'+
            '<th scope="col">Year of<br/> Passing</th>'+
            '<th scope="col">Division/% of <br/>marks obtained</th>'+
            '<th colspan="2" scope="col">Subject/<br/>Specialization</th>'+
            '<th colspan="2" scope="col">Action</th>'+
            '</tr>'+
            '</thead>'+
          '</table>')
          }
      
          $('.show_table').append('<table class="table-wrapper">'+
          '<tbody>'+
          '<tr id="row_'+initialization +'">'+
          '<th scope="row">'+ initialization +'</th>'+
          '<td colspan="2">'+formdata.university_name+'</td>'+
          '<td>'+formdata.degree+'</td>'+
          '<td>'+formdata.year_of_passing+'</td>'+
          '<td>'+formdata.marks_obtained+'</td>'+
          '<td colspan="2">'+formdata.subject_specialization+'</td>'+
          '<td colspan="2"><a id="edu_'+ initialization +'" class="btn btn-danger">Delete</a></td>'+
          '</tr>'+
          '</tbody>'+
          '</table>')
          document.querySelector('#edu_'+ initialization).addEventListener('click',()=>{
      
            axios.post(environment.apiUrl+"/Education/deleteEducationList",JSON.stringify({edu_id:response.data.data_id}),{headers:(options.headers)})
            .then((response)=>{
              if(response.data.status==1){
                $('#row_'+initialization).hide()
                alert("Education deleted successfully")
              }
            })
        
          } )
          setInitialization(initialization+1)
        }
      }) 
    }

   }
    
  }

  

  function handleFormSubmit(e){
    e.preventDefault();
    formdata.user_id=parseInt(sessionStorage.getItem("user_id"));
    formdata.university_name=e.target.university_name.value;
    formdata.degree=e.target.degree.value;
    formdata.year_of_passing=e.target.year_of_passing.value;
    formdata.marks_obtained=e.target.division_or_marks_obtained.value;
    formdata.subject_specialization=e.target.subject_or_specialization.value;

    setFormData(...[formdata]);

    handleFormValidation()
    
  }


 
  const getEducationQualification=()=>{
    
    axios.post(environment.apiUrl+"/Education/getEducationDetails",JSON.stringify({user_id:parseInt(sessionStorage.getItem("user_id"))}),{headers:(options.headers)})
    .then((response)=>{
     
      if(response['data']['status']==1){
        setInitialization(initialization+response.data.data.length)
        setCreateEduStatus('1')
        props.data(response['data']['status'])
        setData({
          ...data,data:response['data']
        })
       
          if(createEduStatus=='0'){
          
            $('.show_table').append('<table class="table-wrapper">'+
            '<thead>'+
            '<tr>'+
            '<th scope="col">S.No.</th>'+
            '<th colspan="2" scope="col">Name of University/<br/>Equivalent Institute</th>'+
            '<th scope="col">Degree</th>'+
            '<th scope="col">Year of<br/> Passing</th>'+
            '<th scope="col">Division/% of <br/>marks obtained</th>'+
            '<th colspan="2" scope="col">Subject/<br/>Specialization</th>'+
            '<th colspan="2" scope="col">Action</th>'+
            '</tr>'+
            '</thead>'+
          '</table>')
         
          }
          
         // if(formdata.university_name!=='' && formdata.degree!=='' && formdata.year_of_passing!=='' && formdata.marks_obtained!=='' && formdata.subject_specialization!==''){
          for(let i=0;i<response.data.data.length;i++){
            setDataLength(i)
            $('.show_table').append('<table class="table-wrapper">'+
            '<tbody>'+
            '<tr id="row_'+i+'">'+
            '<th scope="row">'+ initialization++ +'</th>'+
            '<td colspan="2">'+response.data.data[i]['university_name']+'</td>'+
             '<td>'+response.data.data[i]['degree']+'</td>'+
             '<td>'+response.data.data[i]['year_of_passing']+'</td>'+
             '<td>'+response.data.data[i]['marks_obtained']+'</td>'+
             '<td colspan="2">'+response.data.data[i]['subject_specialization']+'</td>'+
            '<td colspan="2"><a id="edu_'+ i +'" class="btn btn-danger">Delete</a></td>'+
            '</tr>'+
            '</tbody>'+
            '</table>')
           
        }
    //  }
        for(let i=0;i<response.data.data.length;i++){
          setDataLength(i+2)
        document.querySelector('#edu_'+i).addEventListener('click',()=>{
          let a=i;
          axios.post(environment.apiUrl+"/Education/deleteEducationList",JSON.stringify({edu_id:response.data.data[0]['id']}),{headers:(options.headers)})
          .then((response)=>{
            if(response.data.status==1){
              $('#row_'+a).hide()
              alert("Education deleted successfully")
            }
          })
      
        } )
        }
      }
    })
  }


  useEffect(()=>{
    if(apiCall==0){
      getEducationQualification()
    }
    setApiCall(1)
   },[apiCall])

  const add=(event)=>{
    if(data.data=='' || createEduStatus=='0'){
     
      $('.show_table').append('<table class="table table-striped">'+
      '<thead>'+
      '<tr>'+
      '<th scope="col">S.No.</th>'+
      '<th scope="col">Name of University/<br/>Equivalent Institute</th>'+
      '<th scope="col">Degree</th>'+
      '<th scope="col">Year of<br/> Passing</th>'+
      '<th scope="col">Division/% of <br/>marks obtained</th>'+
      '<th scope="col">Subject/<br/>Specialization</th>'+
      '<th scope="col">Action</th>'+
      '</tr>'+
      '</thead>'+
    '</table>')
    }
    if(formdata.university_name!=='' && formdata.degree!=='' && formdata.year_of_passing!=='' && formdata.marks_obtained!=='' && formdata.subject_specialization!==''){
    $('.show_table').append('<table class="table table-striped">'+
    '<tbody>'+
    '<tr>'+
    '<th scope="row" id="row_'+datalength+'">'+ ( datalength) + '</th>'+
    // '<th scope="row">'+(parseInt((data.data.data).length+1))==undefined?i++:parseInt((data.data.data).length+1) + '</th>'+
    '<td>'+formdata.university_name+'</td>'+
    '<td>'+formdata.degree+'</td>'+
    '<td>'+formdata.year_of_passing+'</td>'+
    '<td>'+formdata.marks_obtained+'</td>'+
    '<td>'+formdata.subject_specialization+'</td>'+
    '<td><button id="edu_'+ datalength +'" class="btn btn-danger">Delete</button></td>'+
    '</tr>'+
    '</tbody>'+
    '</table>')
    }

    document.querySelector('#edu_'+datalength).addEventListener('click',(i)=>{
      axios.post(environment.apiUrl+"/Education/deleteEducationList",JSON.stringify({edu_id:datalength}),{headers:(options.headers)})
          .then((response,i)=>{
            
            if(response.data.status==1){
              $('#row_'+datalength).hide()
              alert("Education deleted successfully")
            }
          })
    } )
    setDataLength(datalength+1)
  }
  
  return (
    <>
    <style>{`
      .table-wrapper {
        width: 100%;
        border-collapse: collapse;
        table-layout: auto;
        margin: 0;
        padding: 0;
      }
      .table-wrapper th, .table-wrapper td {
        padding: 0.75rem;
        text-align: left;
        border: 1px solid #ddd;
        vertical-align: top;
        word-wrap: break-word;
        word-break: break-word;
        overflow-wrap: break-word;
        margin: 0;
      }
      .table-wrapper th {
        background-color: #f8f9fa;
        font-weight: 600;
        min-width: 80px;
      }
      .table-wrapper tr {
        margin: 0;
        padding: 0;
      }
      .table-wrapper tr:hover {
        background-color: #f5f5f5;
      }
      @media (max-width: 768px) {
        .table-wrapper th, .table-wrapper td {
          padding: 0.5rem;
          font-size: 0.9rem;
          min-width: 60px;
        }
      }
    `}</style>
    <div className="container-fluid page-body-wrapper">
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="card-title">Education Qualification</h4>
                        <p className="card-description"> Add atleast 1 education qualification to proceed </p>
                        <form className="forms-sample" onSubmit={(event)=>handleFormSubmit(event)}>
                            <div className="row">
                                <div className="form-group col-6">
                                    <label>Name of University/Equivalent Institute <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" onChange={(e)=>setData({...data,university_name:e.target.value})} name="university_name" id="university_name" placeholder="Name of University"/>
                                </div>
                                <div className="form-group col-6">
                                    <label>Degree <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" name="degree" onChange={(e)=>setData({...data,degree:e.target.value})} id="degree" placeholder="Degree"/>
                                </div>
                            
                            </div>
                            <div className="row">
                                <div className="form-group col-6">
                                    <label>Year of Passing <span className="text-danger">*</span></label>
                                    <input type="number" className="form-control" name="year_of_passing" onChange={(e)=>setData({...data,year_of_passing:e.target.value})} id="year_of_passing" placeholder="Year of Passing"/>
                                </div>
                                <div className="form-group col-6">
                                    <label>Division/% of marks obtained <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" name="division_or_marks_obtained" onChange={(e)=>setData({...data,marks_obtained:e.target.value})} id="division_or_marks_obtained" placeholder="Division/% of marks obtained"/>
                                </div>
                            
                            </div>
                            <div className="row">
                                <div className="form-group col-6">
                                    <label>Subject/Specialization <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" name="subject_or_specialization" onChange={(e)=>setData({...data,subject_specialization:e.target.value})} id="subject_or_specialization" placeholder="Subject/Specialization"/>
                                </div>
                                
                            </div>
                          <div className="form-group"><br/>
                            <button type="submit" style={{width:'100px'}} className="btn btn-primary me-2">Add</button>
                          </div><br/>
                          <div className="show_table" style={{overflowX: 'auto', overflowY: 'hidden', width: '100%', minHeight: '50px'}}>
                          
                          </div>
                          
                        </form>
                        
                      </div>
                    </div>
                  </div>
                </div>
            
    </>
  )
}

export default EducationQualification